import { OverViewWidgetItem } from "../../types";
import { Card, CardContent, Typography, Box } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
type OverViewWidgetProps = {
    overViewWidgetItem: OverViewWidgetItem;
};

export default function OverViewWidget({
    overViewWidgetItem,
}: OverViewWidgetProps) {
    const { icon, title, onClick } = overViewWidgetItem;

    return (
        <Card
            sx={{
                display: "flex",

                alignItems: "center",
                gap: "1rem",
                alignSelf: "stretch",
                borderRadius: "1.5rem",
                background: "#FFF",
                padding: "1.5rem",
                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
                // "@media (min-width:1024px)": {
                //     width: "29.5rem",
                // },
            }}
        >
            <CardContent
                sx={{
                    padding: 0,
                    ":last-child": {
                        paddingBottom: 0,
                    },
                    display: "flex",
                    flexDirection: "row",
                    gap: "1rem",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        width: "3rem",
                        height: "3rem",
                        padding: " 0.75rem",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "0.75rem",
                        background: "#F3F5F6",
                    }}
                >
                    {icon}
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        flex: "1 0 0",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#000",

                            fontFamily: "Roboto",
                            fontSize: "1.125rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.625rem",
                        alignSelf: "stretch",
                    }}
                    onClick={() => {
                        if (onClick) {
                            onClick();
                        }
                    }}
                >
                    <ChevronRightIcon
                        width="1.125rem"
                        height="1.125rem"
                        sx={{
                            // ":hover": {
                            //     transform: "rotate(90deg)",
                            // },
                            cursor: "pointer",
                            float: "left",
                        }}
                    />
                </Box>
            </CardContent>
        </Card>
    );
}
